module.exports = __webpack_public_path__ + "static/media/pic06.295e4ad3.webp";